define('plugin/invoice/view/InvoiceRecurringProfileListCollectionView',['require','marionette','plugin/invoice/view/InvoiceRecurringProfileListItemView'],function (require) {

    var Marionette = require('marionette');
    var InvoiceRecurringProfileListItemView = require('plugin/invoice/view/InvoiceRecurringProfileListItemView');

    /**
     * invoice recurring profile collection view (invoices collection)
     *
     * @class InvoiceRecurringProfileListCollectionView
     */
    return Marionette.CollectionView.extend({

        childView: InvoiceRecurringProfileListItemView

    });

});
